import { render, staticRenderFns } from "./AddTaskAct.vue?vue&type=template&id=10d20d31&scoped=true&"
import script from "./AddTaskAct.vue?vue&type=script&lang=js&"
export * from "./AddTaskAct.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskAct.vue?vue&type=style&index=0&id=10d20d31&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d20d31",
  null
  
)

export default component.exports